import React, { lazy } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import {
  Box as MuiBox,
  CircularProgress as MuiCircularProgress,
  Typography as MuiTypography,
  useTheme,
} from '@mui/material';

import { cutDownText } from 'lib/utils';

const CarePlanCell = ({ carePlan }) => {
  const { t } = useTranslation();
  const theme = useTheme()
  const progress = Math.round((carePlan?.currentDay / carePlan?.endDay) * 100);
  return (
    <CarePlanCellContainer>
      <MuiBox
        sx={{
          maxHeight: '48px',
          padding: '3px 7px 10px',
          whiteSpace: 'nowrap',
          width: '170px',
        }}
      >
        <MuiBox>
          {cutDownText({
            text: carePlan?.title,
            symbolsQtty: 18,
          }) || t('Care plan')}
        </MuiBox>

        {carePlan?.currentDay && carePlan?.endDay ? (
          <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
            <MuiCircularProgress
              style={{ height: '16px', width: '16px' }}
              value={progress}
              variant="determinate"
            />
            <MuiTypography
              variant="subtitle2"
              style={{ color: theme.palette.colors.gray400, marginLeft: '10px' }}
            >
              {`${t('day')} ${carePlan?.currentDay} ${t('of')} ${
                carePlan?.endDay
              }`}
            </MuiTypography>
          </MuiBox>
        ) : null}
      </MuiBox>
    </CarePlanCellContainer>
  );
};

export default React.memo(CarePlanCell);

const CarePlanCellContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  &::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 100%;
    background-color: ${({theme}) => theme.palette.colors.blue100};
  }
`;
